import { render } from "./IndicadorCalidad.vue?vue&type=template&id=6a1cb900"
import script from "./IndicadorCalidad.vue?vue&type=script&lang=js"
export * from "./IndicadorCalidad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Calidad/IndicadorCalidad.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a1cb900"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a1cb900', __exports__)) {
    api.reload('6a1cb900', __exports__)
  }
  
  module.hot.accept("./IndicadorCalidad.vue?vue&type=template&id=6a1cb900", () => {
    api.rerender('6a1cb900', render)
  })

}


export default __exports__